import BodyText, { BoldFormTitle, SmallFormTitle, MedBodyText } from './Text'

const formSection = {
  default: {
    divider: false,
    uploadCondensed: false,
    font: {
      formTitle: BoldFormTitle,
      bodyText: BodyText
    },
    gap: {
      div: '20px',
      subDiv: '15px',
      row: '20px 2%',
      small: '10px'
    },
    label: {
      fontSize: '16px'
    },
    muiTextField: {
      labelFontSize: '22px',
      topMargin: '26px',
      basis: '23.5%'
    },
    muiCheckbox: {
      margin: '-2px'
    },
    padding: {
      subsection: '20px 30px 30px'
    }
  },
  condensed: {
    divider: true,
    uploadCondensed: true,
    font: {
      formTitle: SmallFormTitle,
      bodyText: MedBodyText
    },
    gap: {
      div: '15px',
      subDiv: '10px',
      row: '10px 1%',
      small: '5px'
    },
    label: {
      fontSize: '14px'
    },
    muiTextField: {
      labelFontSize: '19px',
      topMargin: '23px',
      basis: '24.25%'
    },
    muiCheckbox: {
      margin: '-4px'
    },
    padding: {
      subsection: '10px 15px 15px'
    }
  }
}

const formWording = {
  requestor: {
    pronoun: 'you',
    possessive: 'your',
    objectPronoun: 'you'
  },
  staff: {
    pronoun: 'they',
    possessive: 'their',
    objectPronoun: 'them'
  }
}

export { formSection, formWording }
